import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function SubmitBanner() {
  return (
    <section className="mx-auto w-full px-4 py-14 md:px-10 md:py-20">
      <div className="relative overflow-hidden rounded-lg border border-primary-500/25 bg-gradient-to-br from-background-100 via-background-100 to-primary-950/50 p-7 md:p-12">
        <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-500/10 blur-2xl"></div>
        <div className="pointer-events-none absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-accent-500/10 blur-2xl"></div>

        <div className="relative grid grid-cols-1 gap-8 lg:grid-cols-[1.4fr_1fr] lg:items-center">
          <div>
            <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-50 md:text-3xl">
              你手上那条料，可能正是别人等了一整晚的
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-400">
              {siteInfo.name}长期接收匿名投稿。文字描述、截图、公开文件都可以，我们默认匿名处理，不会对外披露线索人身份。进入核实流程的线索，编辑会在 48 小时内回复。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-950 transition-colors hover:bg-primary-400"
              >
                <i className="ri-send-plane-fill"></i>
                提交线索
              </Link>
              <Link
                to="/faq"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-6 py-3 text-sm text-foreground-200 transition-colors hover:border-primary-500/60 hover:text-primary-300"
              >
                <i className="ri-question-line"></i>
                先看投稿说明
              </Link>
            </div>
          </div>

          <dl className="grid grid-cols-2 gap-4">
            <div className="rounded-lg border border-background-200/80 bg-background-50/60 p-4">
              <dt className="text-xs text-foreground-500">投稿邮箱</dt>
              <dd className="mt-1.5 break-all text-sm text-foreground-100">{siteInfo.submitEmail}</dd>
            </div>
            <div className="rounded-lg border border-background-200/80 bg-background-50/60 p-4">
              <dt className="text-xs text-foreground-500">编辑在线时段</dt>
              <dd className="mt-1.5 text-sm text-foreground-100">{siteInfo.contactHours}</dd>
            </div>
            <div className="rounded-lg border border-background-200/80 bg-background-50/60 p-4">
              <dt className="text-xs text-foreground-500">平均响应</dt>
              <dd className="mt-1.5 text-sm text-foreground-100">48 小时内</dd>
            </div>
            <div className="rounded-lg border border-background-200/80 bg-background-50/60 p-4">
              <dt className="text-xs text-foreground-500">匿名保护</dt>
              <dd className="mt-1.5 text-sm text-foreground-100">默认开启</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}